var exports = {
  "Nr": "x234b8571--aefea7--card",
  "Sl": "x234b8571--aefea7--image",
  "Qq": "x234b8571--aefea7--text",
  "At": "x234b8571--aefea7--text__inner",
  "El": "x234b8571--aefea7--image--desktop",
  "Lw": "x234b8571--aefea7--overlay",
  "PW": "x234b8571--aefea7--overlay__inner",
};

module.exports = exports;
